<div
	class="flex h-full min-h-0 flex-col"
	id="wrapper"
>
	<tg-toolbar
		hideTeams
		showFrill
		tbclass="mat-toolbar-tg mat-toolbar-base --timer-rc-header mat-elevation-z0"
	></tg-toolbar>
	<div class="mx-6 my-2 flex shrink-0 flex-col gap-2">
		<div class="flex flex-row items-center justify-end gap-2">
			@if(schedule$ | async; as sched) {
			<div class="flex flex-row items-center gap-6 mat-bd-5 rounded-lg px-2 h-full">
				<div class="flex flex-col items-center">
					<span
						[matTooltip]="( 'timer.calendar.should' | translate ) + ' ' + (sched.max | parseMsAsDuration)"
						class="text-center block"
					>
						{{ sched.max | parseMsAsDuration }}
					</span>
				</div>
				@if(projecthoursEnabled.value$ | async) {
				<div class="flex flex-col items-center">
					<span
						[matTooltip]="('timer.calendar.projecthours' | translate) + ' ' + (sched.projecthours.percent | percent)"
					>
						<span class="flex flex-row items-center gap-2">
							<span>{{ sched.projecthours.used | parseMsAsDuration }}</span>
							<div class="mat-circle-card">
								<mat-progress-spinner
									[color]="sched.projecthours.graphState"
									[diameter]="18"
									[value]="sched.projecthours.percent * 100 | clamp: 0 : 100"
									class="with-back-spinner"
									strokeWidth="3"
								></mat-progress-spinner>
							</div>
						</span>
					</span>
				</div>
				} @if(workinghoursEnabled.value$ | async) {
				<div class="flex flex-col items-center">
					<span
						[matTooltip]="('timer.calendar.workinghours' | translate)	+ ' ' + (sched.workinghours.percent | percent)"
					>
						<span class="flex flex-row items-center gap-2">
							<span>{{ sched.workinghours.used | parseMsAsDuration }}</span>
							<div class="mat-circle-card">
								<mat-progress-spinner
									[color]="sched.workinghours.graphState"
									[diameter]="18"
									[value]="sched.workinghours.percent * 100 | clamp: 0 : 100"
									class="with-back-spinner"
									strokeWidth="3"
								></mat-progress-spinner>
							</div>
						</span>
					</span>
				</div>
				}
			</div>
			}
			<div
				*ngIf="selectedViewMode.value$ | async as view"
				class="flex h-12 items-center justify-end space-x-2 rounded-lg border border-gray-200/80 bg-white px-2 shadow shadow-gray-700/10 dark:border-neutral-800 dark:bg-transparent dark:shadow-none"
			>
				<div class="relative">
					<button
						(click)="viewChange('calendar')"
						[class.bg-primary-2]="!displayModeLoading && view === 'calendar'"
						[disabled]="displayModeLoading"
						[ngClass]="{ '!rounded-md !w-9 !h-9': isMobile$xs | async }"
						[send-tagmanager_event]="{
							category: 'feature',
							action: 'button tableDisplayMode tableDisplayMode_Simple',
						}"
						class="flex flex-col items-center justify-center !rounded-lg"
						color="primary"
						mat-button
					>
						@if (isMobile$xs | async) {<mat-icon>view_timeline</mat-icon>} @else {
						{{ 'utils.tableDisplayMode.calendar' | translate }}}
					</button>
				</div>
				<ng-container>
					<div class="relative">
						<button
							(click)="viewChange('list')"
							[class.bg-primary-2]="!displayModeLoading && view === 'list'"
							[disabled]="displayModeLoading"
							[ngClass]="{ '!rounded-md !w-9 !h-9': isMobile$xs | async }"
							[send-tagmanager_event]="{
								category: 'feature',
								action: 'button tableDisplayMode tableDisplayMode_Simple',
							}"
							class="flex flex-col items-center justify-center !rounded-lg"
							color="primary"
							mat-button
						>
							@if (isMobile$xs | async) {<mat-icon>work_history</mat-icon>} @else {
							{{ 'utils.tableDisplayMode.list' | translate }}}
						</button>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
	<div
		*ngIf="selectedViewMode.value$ | async as view"
		class="flex min-h-0 flex-1 flex-col"
	>
		@if (view === 'calendar') {
		<app-calendar-view></app-calendar-view>
		} @else {
		<div class="timer-content-wrapper">
			<div class="timer-content">
				<div class="container">
					<div class="time-entries-wrapper mt-1 flex flex-col pb-[256px]">
						<app-list-view></app-list-view>
					</div>
				</div>
			</div>
		</div>
		}
	</div>
</div>
